module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-5.c0ebab24.png";